export default (slug: string | undefined): string => (slug
  ? slug.replace(/^\/*/, '/')
  : ''
);
